<template>
    <div>
        <h1> {{message}} </h1>
    </div>
</template>

<style scoped>
h1 {
    color: red
}
</style>

<script>
export default {
    name: "Example",
    data() {
        return {
            message: "Example Vue Component"
        }
    }
}
</script>


